import { FormControl, InputLabel } from '@mui/material';
import { red } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';

const useStyles = makeStyles({
  container: {
    padding: '8px 8px 2px 8px',
  },
  formControlLabel: {
    transform: 'translate(14px, -6px) scale(0.75)',
    background: '#FFF',
    fontSize: '1rem',
    fontWeight: 400,
    marginLeft: '-5px',
    borderLeft: '4px solid #FFF',
    borderRight: '4px solid #FFF',
  },
  formControlActive: {
    outline: '2px solid #0066cc',
  },
  formControlMouseOver: {
    outline: '1px solid #000',
  },
});

interface IOutlinedFormControl {
  label?: string;
  required?: boolean;
  error?: boolean;

  style?: React.CSSProperties;

  children: React.ReactNode;
}

const OutlinedFormControl = (props: IOutlinedFormControl) => {
  const classes = useStyles();
  const [isMousedOver, setIsMousedOver] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const style = props.style
    ? {
        ...props.style,
        ...{
          border: `1px solid ${props.error ? red[500] : '#c4c4c4'}`,
          borderRadius: '4px',
        },
      }
    : undefined;

  return (
    <>
      <FormControl
        style={style}
        required={props.required}
        error={props.error}
        className={
          isActive
            ? classes.formControlActive
            : isMousedOver
            ? classes.formControlMouseOver
            : undefined
        }
        onMouseOver={() => {
          setIsMousedOver(true);
        }}
        onMouseOut={() => {
          setIsMousedOver(false);
        }}
      >
        <div
          className={classes.container}
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
        >
          {props.label && (
            <InputLabel
              className={classes.formControlLabel}
              style={isActive ? { color: '#0066cc' } : undefined}
              disableAnimation
            >
              {props.label}
            </InputLabel>
          )}
          {props.children}
        </div>
      </FormControl>
    </>
  );
};

export default OutlinedFormControl;
